(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bp_comparison-by-category"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('category-comparison')) {
    customElements.define(
      'category-comparison',
      class extends HTMLElement {
        connectedCallback() {
          cancelAnimationFrame(this.initFrame);
          this.initFrame = requestAnimationFrame(() => this.initialize());
        }
        initialize() {
          this.abortController?.abort();
          this.abortController = new AbortController();
          const { signal } = this.abortController;
          this.viewport = this.querySelector('.cbc-section__track');
          this.groups = [...this.viewport.querySelectorAll('[data-cc-group]')];
          this.products = [...this.viewport.querySelectorAll('[data-cc-product]')];
          this.arrows = [...this.querySelectorAll('[data-cc-direction]')];
          this.rtl = getComputedStyle(this).direction === 'rtl';
          const controls = this.querySelector('.cc-categories');
          const descriptions = this.querySelector('.cc-descriptions');
          controls.replaceChildren();
          descriptions.replaceChildren();
          this.buttons = [];
          this.descriptions = [];
          this.groups.forEach((group) => {
            const category = group.dataset.ccGroup;
            const products = this.products.filter((product) => product.closest('[data-cc-group]') === group);
            products.forEach((product, index) => {
              product.dataset.ccCell = category;
              product.classList.toggle('cc-category-start', index === 0);
            });
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'cc-category-button';
            button.dataset.ccCategory = category;
            const sourceImage = group.querySelector('.cc-source-image');
            if (sourceImage) {
              const image = sourceImage.cloneNode(true);
              image.className = 'cc-category-image';
              image.alt = '';
              button.append(image);
            }
            const label = document.createElement('span');
            label.className = 'cc-category-label';
            label.textContent = group.querySelector('[data-cc-title]').textContent;
            button.append(label);
            button.disabled = products.length === 0;
            button.setAttribute('aria-pressed', 'false');
            const description = group.querySelector('.cc-source-description').cloneNode(true);
            description.className = 'cc-description rte';
            description.id = `${this.id}-description-${category}`;
            description.dataset.ccDescription = category;
            description.hidden = true;
            if (!products.length) {
              const empty = document.createElement('p');
              empty.textContent = this.dataset.emptyCategoryLabel;
              description.append(empty);
            }
            button.setAttribute('aria-controls', `${this.viewport.id} ${description.id}`);
            button.addEventListener('click', () => this.selectCategory(category), { signal });
            controls.append(button);
            descriptions.append(description);
            this.buttons.push(button);
            this.descriptions.push(description);
          });
          controls.hidden = !this.groups.length;
          descriptions.hidden = !this.groups.length || this.dataset.showDescription !== 'true';
          this.setAttribute('data-enhanced', '');
          const first = this.buttons.find((button) => !button.disabled)?.dataset.ccCategory;
          this.products.forEach((product) =>
            product.toggleAttribute('data-cc-first-group', product.dataset.ccCell === first)
          );
          this.arrows.forEach((button) =>
            button.addEventListener(
              'click',
              () => {
                const product = this.products.find((item) => !item.hidden);
                if (!product) return;
                const direction = Number(button.dataset.ccDirection) * (this.rtl ? -1 : 1);
                const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
                this.viewport.scrollBy({
                  left: direction * (product.getBoundingClientRect().width + gap),
                  behavior: this.motion(),
                });
              },
              { signal }
            )
          );
          this.viewport.addEventListener(
            'scroll',
            () => {
              this.updateArrows();
              clearTimeout(this.scrollTimer);
              this.scrollTimer = setTimeout(() => this.syncCategory(), 180);
            },
            { signal, passive: true }
          );
          this.addEventListener(
            'comparison:select',
            (event) => {
              if (event.detail?.category) this.selectCategory(event.detail.category);
            },
            { signal }
          );
          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const selectedProduct = event.target instanceof Element ? event.target.closest('[data-cc-product]') : null;
              const product = this.products.find(
                (item) => item === selectedProduct || item.dataset.ccProduct === event.detail.blockId
              );
              const group = this.groups.find((item) => item.dataset.ccGroup === event.detail.blockId);
              const category = product?.dataset.ccCell || group?.dataset.ccGroup;
              if (category) this.selectCategory(category, false);
              if (product) this.scrollToProduct(product, false);
            },
            { signal }
          );
          this.resizeObserver?.disconnect();
          this.resizeObserver = new ResizeObserver(() => {
            this.updateTail();
            this.updateArrows();
          });
          this.resizeObserver.observe(this.viewport);
          const initial =
            this.buttons.find((button) => !button.disabled && button.dataset.ccCategory === this.activeCategory)
              ?.dataset.ccCategory ||
            first ||
            this.groups[0]?.dataset.ccGroup;
          if (initial) this.selectCategory(initial, false);
          this.updateArrows();
          this.dispatchEvent(new CustomEvent('comparison:ready', { bubbles: true }));
        }
        disconnectedCallback() {
          cancelAnimationFrame(this.initFrame);
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
          clearTimeout(this.scrollTimer);
        }
        motion() {
          return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        }
        setActive(category) {
          this.activeCategory = category;
          this.buttons.forEach((button) =>
            button.setAttribute('aria-pressed', String(button.dataset.ccCategory === category))
          );
          const button = this.buttons.find((item) => item.dataset.ccCategory === category);
          if (button) {
            const rail = this.querySelector('.cc-categories');
            const rect = button.getBoundingClientRect();
            const bounds = rail.getBoundingClientRect();
            let delta = 0;
            if (rect.left < bounds.left) delta = rect.left - bounds.left;
            else if (rect.right > bounds.right) delta = rect.right - bounds.right;
            if (delta) rail.scrollBy({ left: delta, behavior: this.motion() });
          }
          this.descriptions.forEach((description) => {
            description.hidden = description.dataset.ccDescription !== category;
          });
        }
        selectCategory(category, animate = true) {
          if (!this.groups?.some((group) => group.dataset.ccGroup === category)) return;
          clearTimeout(this.scrollTimer);
          this.setActive(category);
          this.groups.forEach((group) => {
            group.hidden = this.dataset.mode === 'filter' && group.dataset.ccGroup !== category;
          });
          this.products.forEach((product) => {
            product.hidden = this.dataset.mode === 'filter' && product.dataset.ccCell !== category;
          });
          this.updateTail();
          const first = this.products.find((product) => product.dataset.ccCell === category);
          if (this.dataset.mode === 'filter') this.viewport.scrollTo({ left: 0, behavior: 'instant' });
          else if (first) this.scrollToProduct(first, animate);
          this.updateArrows();
        }
        scrollToProduct(product, animate) {
          const viewport = this.viewport.getBoundingClientRect();
          const rect = product.getBoundingClientRect();
          const delta = this.rtl ? rect.right - viewport.right : rect.left - viewport.left;
          this.viewport.scrollTo({
            left: this.viewport.scrollLeft + delta,
            behavior: animate ? this.motion() : 'instant',
          });
        }
        updateTail() {
          const tailElement = this.querySelector('.cc-scroll-tail');
          let tail = 0;
          if (this.dataset.mode === 'scroll' && this.products.length) {
            const last = this.products[this.products.length - 1];
            const first = this.products.find((product) => product.dataset.ccCell === last.dataset.ccCell);
            const firstRect = first.getBoundingClientRect();
            const lastRect = last.getBoundingClientRect();
            const width = this.rtl ? firstRect.right - lastRect.left : lastRect.right - firstRect.left;
            const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
            tail = Math.max(0, this.viewport.clientWidth - width - gap);
          }
          tailElement.toggleAttribute('data-needed', tail > 0);
          this.style.setProperty('--cc-tail', `${tail}px`);
        }
        syncCategory() {
          if (this.dataset.mode !== 'scroll' || !this.products.length) return;
          const viewport = this.viewport.getBoundingClientRect();
          let category = this.products[0].dataset.ccCell;
          this.products
            .filter((product) => product.classList.contains('cc-category-start'))
            .forEach((product) => {
              const rect = product.getBoundingClientRect();
              const distance = this.rtl ? viewport.right - rect.right : rect.left - viewport.left;
              if (distance <= 4) category = product.dataset.ccCell;
            });
          this.setActive(category);
        }
        updateArrows() {
          const visible = this.products.some((product) => !product.hidden);
          this.querySelector('.cc-arrows').hidden = !visible;
          const position = Math.abs(this.viewport.scrollLeft);
          const max = this.viewport.scrollWidth - this.viewport.clientWidth;
          this.arrows[0].disabled = !visible || position <= 1;
          this.arrows[1].disabled = !visible || position >= max - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // console.log('sticky header');
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      // console.log('setting --header-height', performance.now(), `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bp-multicolumn-count-up')) {
  customElements.define('bp-multicolumn-count-up', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const visual = this.querySelector('[data-count-up-text]');
      if (!visual || this.motion.matches || !('IntersectionObserver' in window)) return;
      this.parts = [];
      const walker = document.createTreeWalker(visual, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const original = node.nodeValue;
        const matches = [...original.matchAll(/(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?/g)];
        const tokens = matches.map((match) => {
          const raw = match[0];
          const decimals = (raw.split('.')[1] || '').length;
          return { raw, index: match.index, target: Number(raw.replaceAll(',', '')), decimals };
        });
        if (tokens.length && tokens.every((token) => Number.isFinite(token.target) && token.target <= Number.MAX_SAFE_INTEGER && token.decimals <= 6)) {
          this.parts.push({ node, original, tokens });
        }
      }
      if (!this.parts.length) return;
      this.onMotionChange = () => { if (this.motion.matches) this.finish(); };
      this.motion.addEventListener('change', this.onMotionChange);
      this.paint(0);
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35)) {
          this.observer.disconnect();
          this.frame = requestAnimationFrame((time) => this.tick(time));
        }
      }, { threshold: 0.35 });
      this.observer.observe(this.querySelector('h3'));
    }

    paint(progress) {
      for (const part of this.parts) {
        let cursor = 0;
        let output = '';
        for (const token of part.tokens) {
          let number = (token.target * progress).toFixed(token.decimals);
          let [integer, fraction] = number.split('.');
          if (token.raw.includes(',')) integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          const rawInteger = token.raw.split('.')[0];
          if (!token.raw.includes(',') && /^0\d/.test(rawInteger)) integer = integer.padStart(rawInteger.length, '0');
          number = fraction === undefined ? integer : `${integer}.${fraction}`;
          output += part.original.slice(cursor, token.index) + number;
          cursor = token.index + token.raw.length;
        }
        part.node.nodeValue = output + part.original.slice(cursor);
      }
    }

    tick(time) {
      if (!this.isConnected) return;
      if (this.startedAt === undefined) this.startedAt = time;
      const progress = Math.min((time - this.startedAt) / 1600, 1);
      this.paint(1 - Math.pow(1 - progress, 3));
      if (progress < 1) this.frame = requestAnimationFrame((next) => this.tick(next));
      else this.finish();
    }

    finish() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      for (const part of this.parts || []) part.node.nodeValue = part.original;
      if (this.onMotionChange) this.motion.removeEventListener('change', this.onMotionChange);
    }

    disconnectedCallback() {
      this.finish();
      this.initialized = false;
      this.startedAt = undefined;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
